
import constant from '../../constant'
import { getAppName } from '../../../utils'
import { APP_INFO } from '../../../utils/constant'

/*
downloading:下载中
downloadcanceled: 暂停或者取消
downloaded：下载完成
installed：安装完成
*/
let appName = APP_INFO[getAppName()].appName;

const initialState = {
  downLoadScene: '',
  downLoadStatus: '',
  progressValue: '',
  tagText: `打开${appName}阅读`,
  loadingText: '',
  bannerClass: '',
  barActive: false
};

function setLoadingText(downLoadScene = 'other', downLoadStatus) {
  const appInfo = APP_INFO[getAppName()] || {};
  appName = appInfo.appName;
  const loadingTextMap = {
    bar: `正在下载${appName}，安装完即可阅读精彩资讯`,
    article: `正在下载${appName}，安装完即可阅读全文`,
    comment: `正在下载${appName}，安装完即可查看全部评论`,
    recommend: `正在下载${appName}，安装完即可阅读精彩资讯`,
    backNews: `正在下载${appName}，安装完即可阅读精彩资讯`,
    image: `正在下载${appName}，安装完即可看高清大图`,
    hotRank: `正在下载${appName}，安装完即可查看热搜`,
    welfare: `正在下载${appName}，安装完即可领取福利`,
    other: `正在下载${appName}，安装完即可打开应用`,
    videoHD: `正在下载${appName}，安装完播放高清视频`,
    videoRecommend: `正在下载${appName}，安装完打开指定视频`,
    videoImage: `正在下载${appName}，安装完提高流畅体验`,
    videoAuthor: `正在下载${appName}，安装完打开创作者主页`,
    videoComment: `正在下载${appName}，安装完打开全部评论`,
    videoMoreRec: `正在下载${appName}，安装完打开更多精彩视频`,
    videoCollection: `正在下载${appName}，安装完打开更多视频合集`,
    shortContent: `正在下载${appName}，安装完即可阅读精彩内容`,
    mediaComment: `正在下载${appName}，即将与创作者和互动`,
    commonComment: `正在下载${appName}，即将打开更多热评`,
    eCommerceFission: `正在下载QQ浏览器, 参与活动为好友助力`
  };
  let loadingText = loadingTextMap[downLoadScene];

  if (downLoadStatus === 'downloading') {
    loadingText = loadingTextMap[downLoadScene];
  } else if (downLoadStatus === 'downloadcanceled') {
    loadingText = `已暂停下载${downLoadScene === 'eCommerceFission' ? 'QQ浏览器' : appName}，点击继续`;
  }

  return loadingText;
}

function setBannerClass(downLoadScene = 'bar', downLoadStatus) {
  let bannerClass = '';
  if (downLoadStatus === 'downloading' || downLoadStatus === 'downloadcanceled') {
    bannerClass = (downLoadScene === 'bar') ? 'bar-downloading' : 'other-downloading';
  }
  return bannerClass;
}

export function downloadBar(state = initialState, { type, payload }) {


  switch (type) {
    case constant.DOWNLOADBAR.DOWNLOAD_SCENE:
      return {
        ...state,
        loadingText: setLoadingText(payload, state.downLoadStatus),
        bannerClass: setBannerClass(payload, state.downLoadStatus),
        downLoadScene: payload
      }

    case constant.DOWNLOADBAR.DOWNLOAD_STATUS:
      return {
        ...state,
        loadingText: setLoadingText(state.downLoadScene, payload),
        bannerClass: setBannerClass(state.downLoadScene, payload),
        downLoadStatus: payload
      }
    case constant.DOWNLOADBAR.PROGRESS_VALUE:
      return {
        ...state,
        progressValue: `${payload}%`
      }
    case constant.DOWNLOADBAR.BAR_ACTIVE:
      return {
        ...state,
        barActive: payload
      }
    default:
      return state;
  }
};
